<div id="preview-container" *ngIf="svg" (window:resize)="onResize($event)" style="position: relative; pointer-events: none;">
  <hb-drawing-preview-legend *ngIf="drawingInspectionDetails" [inspectionPointTypes]="drawingInspectionDetails.inspectionPointTypes"></hb-drawing-preview-legend>

  <div id="navigation-container">
    <div id="preview">
      <div id="svg-container" [innerHTML]="svg" #svgContainer style="position: relative; pointer-events: none;"></div>
      <hb-inspection-point-overlay></hb-inspection-point-overlay>
    </div>
    <div id="navigation">
      <hb-drawing-preview-navigation *ngIf="showNavigation && svgElement" [svgElement]="svgElement" (zoom)="onZoom($event)" style="pointer-events: all;"></hb-drawing-preview-navigation>
    </div>
  </div>
</div>